
// //  Product Title & Image
// document.addEventListener("DOMContentLoaded", function () {
//     function updateWishlistCounter() {
//         let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
//         document.querySelector(".wishlist-counter").textContent = wishlist.length;
//     }

//     document.querySelectorAll(".wishlist-btn").forEach((btn) => {
//         btn.addEventListener("click", function () {
//             let productId = this.getAttribute("data-product-id");
//             let productTitle = this.getAttribute("data-product-title"); // Get the product title
//             let productImage = this.getAttribute("data-product-image"); // Get the product image
//             let productPrice = this.getAttribute("data-product-price"); // Get the product Price
//             let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

//             console.log(`Adding/Removing product: ID = ${productId}, Title = ${productTitle}, Image = ${productImage}, Price = ${productPrice} `);  // Log product ID title, image

//             let wishlistItem = wishlist.find(item => item.id === productId);

//             if (wishlistItem) {
//                 wishlist = wishlist.filter(item => item.id !== productId);
//                 this.querySelector(".wishlist-text").textContent = "Add to Wishlist";
//                 showNotification("Removed from Wishlist", "error");
//             } else {
//                 wishlist.push({ id: productId, title: productTitle, image : productImage, price : productPrice }); // Store both ID & Title
//                 this.querySelector(".wishlist-text").textContent = "Remove from Wishlist";
//                 showNotification("Added to Wishlist", "success");
//             }

//             localStorage.setItem("wishlist", JSON.stringify(wishlist));

//             console.log("Wishlist Updated:", wishlist); // Log the updated wishlist
//             updateWishlistCounter();
//         });
//     });

//     function showNotification(message, type) {
//         let notification = document.createElement("div");
//         notification.className = `wishlist-notification ${type}`;
//         notification.innerText = message;
//         document.body.appendChild(notification);

//         setTimeout(() => {
//             notification.remove();
//         }, 3000);
//     }

//     updateWishlistCounter();
// });


document.addEventListener("DOMContentLoaded", function () {
    function updateWishlistCounter() {
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
        document.querySelector(".wishlist-counter").textContent = wishlist.length;
    }

    function loadWishlistState() {
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

        document.querySelectorAll(".wishlist-btn").forEach((btn) => {
            let productId = btn.getAttribute("data-product-id");
            let wishlistItem = wishlist.find(item => item.id === productId);
            let icon = btn.querySelector(".wishlist-icon"); 
            let text = btn.querySelector(".wishlist-text");

            if (wishlistItem) {
                text.textContent = "Remove from Wishlist";
                icon.innerHTML = wishlistItem.iconState; // Load the stored icon
            } else {
                text.textContent = "Add to Wishlist";
                icon.innerHTML = `
                  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 17.7329L8.89625 16.7407C7.23858 15.2368 5.86775 13.9446 4.78375 12.8639C3.69975 11.7831 2.84075 10.8212 2.20675 9.97815C1.57275 9.13532 1.12983 8.3664 0.878 7.6714C0.626 6.97657 0.5 6.27149 0.5 5.55615C0.5 4.13699 0.9785 2.94882 1.9355 1.99165C2.89267 1.03465 4.08083 0.556152 5.5 0.556152C6.373 0.556152 7.198 0.760319 7.975 1.16865C8.752 1.57699 9.427 2.16257 10 2.9254C10.573 2.16257 11.248 1.57699 12.025 1.16865C12.802 0.760319 13.627 0.556152 14.5 0.556152C15.9192 0.556152 17.1073 1.03465 18.0645 1.99165C19.0215 2.94882 19.5 4.13699 19.5 5.55615C19.5 6.27149 19.374 6.97657 19.122 7.6714C18.8702 8.3664 18.4272 9.13532 17.7932 9.97815C17.1592 10.8212 16.3018 11.7831 15.221 12.8639C14.1403 13.9446 12.7679 15.2368 11.1038 16.7407L10 17.7329ZM10 15.7062C11.6 14.2665 12.9167 13.0325 13.95 12.0042C14.9833 10.976 15.8 10.0827 16.4 9.3244C17 8.56607 17.4167 7.89265 17.65 7.30415C17.8833 6.71582 18 6.13315 18 5.55615C18 4.55615 17.6667 3.72282 17 3.05615C16.3333 2.38949 15.5 2.05615 14.5 2.05615C13.7103 2.05615 12.9805 2.28015 12.3105 2.72815C11.6407 3.17632 11.1102 3.79974 10.7192 4.5984H9.28075C8.88325 3.79324 8.35117 3.16824 7.6845 2.7234C7.01783 2.27857 6.28967 2.05615 5.5 2.05615C4.50633 2.05615 3.67458 2.38949 3.00475 3.05615C2.33492 3.72282 2 4.55615 2 5.55615C2 6.13315 2.11667 6.71582 2.35 7.30415C2.58333 7.89265 3 8.56607 3.6 9.3244C4.2 10.0827 5.01667 10.9744 6.05 11.9994C7.08333 13.0244 8.4 14.26 10 15.7062Z" fill="white"/>
                  </svg>
                `;
            }
        });
    }

    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
        btn.addEventListener("click", function () {
            let productId = this.getAttribute("data-product-id");
            let productTitle = this.getAttribute("data-product-title");
            let productImage = this.getAttribute("data-product-image");
            let productPrice = this.getAttribute("data-product-price");
            let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

            let wishlistItem = wishlist.find(item => item.id === productId);
            let icon = this.querySelector(".wishlist-icon");
            let text = this.querySelector(".wishlist-text");

            if (wishlistItem) {
                wishlist = wishlist.filter(item => item.id !== productId);
                text.textContent = "Add to Wishlist"; 

                // Show outlined heart when removed
                let iconHTML = ` 
                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 17.7329L8.89625 16.7407C7.23858 15.2368 5.86775 13.9446 4.78375 12.8639C3.69975 11.7831 2.84075 10.8212 2.20675 9.97815C1.57275 9.13532 1.12983 8.3664 0.878 7.6714C0.626 6.97657 0.5 6.27149 0.5 5.55615C0.5 4.13699 0.9785 2.94882 1.9355 1.99165C2.89267 1.03465 4.08083 0.556152 5.5 0.556152C6.373 0.556152 7.198 0.760319 7.975 1.16865C8.752 1.57699 9.427 2.16257 10 2.9254C10.573 2.16257 11.248 1.57699 12.025 1.16865C12.802 0.760319 13.627 0.556152 14.5 0.556152C15.9192 0.556152 17.1073 1.03465 18.0645 1.99165C19.0215 2.94882 19.5 4.13699 19.5 5.55615C19.5 6.27149 19.374 6.97657 19.122 7.6714C18.8702 8.3664 18.4272 9.13532 17.7932 9.97815C17.1592 10.8212 16.3018 11.7831 15.221 12.8639C14.1403 13.9446 12.7679 15.2368 11.1038 16.7407L10 17.7329ZM10 15.7062C11.6 14.2665 12.9167 13.0325 13.95 12.0042C14.9833 10.976 15.8 10.0827 16.4 9.3244C17 8.56607 17.4167 7.89265 17.65 7.30415C17.8833 6.71582 18 6.13315 18 5.55615C18 4.55615 17.6667 3.72282 17 3.05615C16.3333 2.38949 15.5 2.05615 14.5 2.05615C13.7103 2.05615 12.9805 2.28015 12.3105 2.72815C11.6407 3.17632 11.1102 3.79974 10.7192 4.5984H9.28075C8.88325 3.79324 8.35117 3.16824 7.6845 2.7234C7.01783 2.27857 6.28967 2.05615 5.5 2.05615C4.50633 2.05615 3.67458 2.38949 3.00475 3.05615C2.33492 3.72282 2 4.55615 2 5.55615C2 6.13315 2.11667 6.71582 2.35 7.30415C2.58333 7.89265 3 8.56607 3.6 9.3244C4.2 10.0827 5.01667 10.9744 6.05 11.9994C7.08333 13.0244 8.4 14.26 10 15.7062Z" fill="white"/>
                    </svg>
                `;
                icon.innerHTML = iconHTML;

                showNotification("Removed from Wishlist", "error");
            } else {
                let iconHTML = icon.innerHTML; // Store current icon
                wishlist.push({ id: productId, title: productTitle, image: productImage, price: productPrice, iconState: iconHTML });
                text.textContent = "Remove from Wishlist";

                // Show filled heart when added
                icon.innerHTML = `
                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M10 17.7329L8.89625 16.7407C7.23858 15.2368 5.86775 13.9446 4.78375 12.8639C3.69975 11.7831 2.84075 10.8212 2.20675 9.97815C1.57275 9.13532 1.12983 8.3664 0.878 7.6714C0.626 6.97657 0.5 6.27149 0.5 5.55615C0.5 4.13699 0.9785 2.94882 1.9355 1.99165C2.89267 1.03465 4.08083 0.556152 5.5 0.556152C6.373 0.556152 7.198 0.760319 7.975 1.16865C8.752 1.57699 9.427 2.16257 10 2.9254C10.573 2.16257 11.248 1.57699 12.025 1.16865C12.802 0.760319 13.627 0.556152 14.5 0.556152C15.9192 0.556152 17.1073 1.03465 18.0645 1.99165C19.0215 2.94882 19.5 4.13699 19.5 5.55615C19.5 6.27149 19.374 6.97657 19.122 7.6714C18.8702 8.3664 18.4272 9.13532 17.7932 9.97815C17.1592 10.8212 16.3018 11.7831 15.221 12.8639C14.1403 13.9446 12.7679 15.2368 11.1038 16.7407L10 17.7329Z" fill="white"/>
                     </svg>
                `;

                showNotification("Added to Wishlist", "success");
            }

            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            updateWishlistCounter();
        });
    });

    function showNotification(message, type) {
        let notification = document.createElement("div");
        notification.className = `wishlist-notification ${type}`;
        notification.innerText = message;
        document.body.appendChild(notification);
        setTimeout(() => notification.remove(), 3000);
    }

    updateWishlistCounter();
    loadWishlistState(); // Ensure wishlist state persists after refresh
});

